import axios from "axios";
const { API_BACKEND_HOST } = process.env;

const api = axios.create({
  baseURL: `${API_BACKEND_HOST}`,
});

interface IFunctionality {
  name: string;
  id: string;
}

interface IFunctionalitiesResponse {
  functionalities: IFunctionality[];
}

export const list = async (admin: boolean) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await await axios.get<IFunctionalitiesResponse>(
    `${API_BACKEND_HOST}${languageId}/v1/Functionality`, {
    params: {
      admin
    }
  });

  return data;
};
